module.exports = __webpack_public_path__ + "img/数字化营销服务商背景.cd1eba84.png";